import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 },
  rootForRoleTenant: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 0
  }
}))

export default useStyles
